export default {
  name: 'Pilares',
  data () {
    return {
      parceria: {
        imagem: 'home/parceria-volkswagen.webp',
        icone: '/carbank-negativa.png'
      }
    }
  }
}
